import { render, staticRenderFns } from "./NoteTable.vue?vue&type=template&id=51b907df"
import script from "./NoteTable.vue?vue&type=script&lang=js"
export * from "./NoteTable.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports